<template>

    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/role' }">角色管理</el-breadcrumb-item>
                    <el-breadcrumb-item>角色管理</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table
                    :data="roles"
                    size="mini"
                    border
                    style="width: 100%">
                    <el-table-column prop="roleName" label="角色名称"></el-table-column>
                    <el-table-column prop="roleStatus" label="状态" :formatter="formatStatus"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间"></el-table-column>
                </el-table>
            </el-col>
        </el-row>

    </div>
    
</template>

<script>

    export default {
        name:'Role',
        data() {
            return {
                role:{
                    condition:{},
                    pageNum: 1,
                    pageSize:0
                },
                drawer: false,
                direction: 'rtl',
                roles: [],
                currentPage: 1,
                pageSize:10,
                total:10,
                timer:'',
            }
        },
        methods: {
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.queryRole();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryRole();
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryRole();
                })
                .catch(() => {});
            },
            queryRole() {
                this.role.pageNum = this.currentPage;
                this.role.pageSize = this.pageSize;
                this.$axios.post("/role/find",this.role).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.roles = res.data.result.list;
                            this.total = res.data.result.total;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            formatStatus(row) {
                return row.roleStatus == "NORMAL" ? "正常": row.percentageStatus == "FROZEN" ? "冻结" : "已删除";
            }
        },
        mounted() {
            this.queryRole();
        }
        
    }


</script>

<style scoped>

   .el-row {
       margin-top: 30px;
       text-align: left;
       padding-left: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }

</style>
